<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="45%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="formData.email" readonly></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nick_name">
        <el-input v-model="formData.nick_name" readonly></el-input>
      </el-form-item>
      <el-form-item label="是否订阅" prop="is_sub">
        <el-radio-group v-model="formData.is_sub">
          <el-radio :label="2">未订阅</el-radio>
          <el-radio :label="1">已订阅</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="身份" prop="worker_id">
        <el-select v-model="formData.extend.worker_id" placeholder="选择身份" filterable>
          <el-option label="选择身份" :value="0"></el-option>
          <el-option v-for="item in workerList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年龄区间" prop="age_id">
        <el-select v-model="formData.extend.age_id" placeholder="选择年龄区间" filterable>
          <el-option label="选择年龄区间" :value="0"></el-option>
          <el-option v-for="item in ageList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所有地区" prop="area_id">
        <el-select v-model="formData.extend.area_id" placeholder="选择地区" filterable>
          <el-option label="选择地区" :value="0"></el-option>
          <el-option v-for="item in areaList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="兴趣" prop="interest_ids">
        <el-checkbox-group v-model="formData.extend.interest_ids">
          <el-checkbox v-for="item in interestList" :label="item.id" :key="item.id">{{item.title}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'user_info',
  props: [
    'visible', 'id', 'workerList', 'ageList', 'areaList', 'interestList'
  ],
  data () {
    return {
      title: '会员详情',
      formData: {
        email: '',
        nick_name: '',
        is_sub: 2,
        extend: {
          worker_id: 0,
          age_id: 0,
          area_id: 0,
          interest_ids: []
        }
      },
      addFormRules: {
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },
    addOpen () {
      this.getInfo(this.id)
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/user/info/' + id)
      if (res.code === 0 && res.data) {
        this.formData.email = res.data.email || ''
        this.formData.nick_name = res.data.nick_name || ''
        this.formData.is_sub = res.data.is_sub || 2
        if (res.data.extend != null) {
          this.formData.extend = res.data.extend
        } else {
          this.formData.extend = {
            worker_id: 0,
            age_id: 0,
            area_id: 0,
            interest_ids: []
          }
        }
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
